<template lang="pug">
  v-main#checkout
    v-card
      v-card-title
        h3.header-title Checkout
      v-card-text.d-flex.flex-column
        b Suborder ID: {{ details.suborderId }}
        b Details: {{ details.orderDesc }}
        b Amount: RM 1.00
        b Remarks: {{ details.orderRemarks }}
      v-card-text
        v-btn(@click="insertPaymentData") TEST
        form(action="https://payment.ipay88.com.my/ePayment/entry.asp" name="ePayment" method="post")
          input(type="hidden" name="MerchantCode" :value="merchantCode")
          input(type="hidden" name="PaymentId" value="2")
          input(type="hidden" name="RefNo" :value="details.suborderId")
          input(type="hidden" name="Amount" value="1.00")
          input(type="hidden" name="Currency" value="MYR")
          input(type="hidden" name="ProdDesc" :value="details.orderDesc")
          input(type="hidden" name="UserName" value="Stephen")
          input(type="hidden" name="UserEmail" value="stephen.chai@codafuture.com")
          input(type="hidden" name="UserContact" value="0128737787")
          input(type="hidden" name="Remark" :value="details.orderRemarks")
          input(type="hidden" name="Lang" value="UTF-8")
          input(type="hidden" name="SignatureType" value="SHA256")
          input(type="hidden" name="Signature" 
          :value="signature")
          input(type="hidden" name="ResponseURL" 
          value="https://anybook.app/complete")
          input(type="hidden" name="BackendURL" 
          value="https://api.codafuture.com/payment")
          input(class="btn accent" type="submit" value="Proceed with Payment" name="Submit")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  data() {
    return {
      merchantCode: "M27531",
      merchantKey: "jhr5oNPuPH",
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    details() {
      return this.$store.state.customer.checkout;
    },
    signature() {
      return this.$helpers.SHA256(
        this.merchantKey +
          this.merchantCode +
          this.details.suborderId +
          "1.00".replace(".", "") +
          "MYR"
      );
    },
    isLocalHost() {
      return /((http([s]){0,1}:\/\/){0,1}(localhost|127.0.0.1){1}(([:]){0,1}[\0-9]{4}){0,1}\/{0,1}){1}/g.test(
        window.location.host
      );
    }
  },
  methods: {
    /*
    paymentRedirectUrl() is used for testing purposes in localhost. This is 
      because ipay88 does not allow access from localhost, hence will have to 
      pass the data directly into the function to be inserted into the ipay88 table.
    */
    insertPaymentData() {
      let url = config.paymentRedirectUrl();

      var json = {
        test: true,
        PaymentId: 2, // MUST BE UNIQUE
        RefNo: this.details.suborderId,
        Amount: 1.00,
        Currency: "RM",
        Remark: "Localhost testing",
        TransId: +new Date(), // MUST BE UNIQUE
        AuthCode: "TEST",
        Status: "1",
        ErrDesc: "Successful",
        Signature: "Andrew",
        CCName: "NG SIO HONG",
        CCNo: "123456",
        CCBankName: "TEST BANK",
        CCCountry: "Malaysia"
      };

      console.log(json);

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.$router.push(
                  `/payment/?status=${json.Status}&o=${this.details.orderId}&id=${json.RefNo}&desc=${json.errDesc}`
                );
              } else {
                this.$swal(
                  this.$t("error.test_payment"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.test_payment"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.test_payment"),
            response.body.message,
            "error"
          );
        });
    }
  }
};
</script>
